import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { config } from "src/app/config";
import { SuperAdminService } from "src/app/super-admin.service";
import { Observable } from "rxjs";
import { NgxSpinnerService } from "ngx-spinner";
import { ImagePreviewComponent } from "../image-preview/image-preview.component";
import { DomSanitizer } from "@angular/platform-browser";
import { map, startWith } from "rxjs/operators";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-add-lr-module",
  templateUrl: "./add-lr-module.component.html",
  styleUrls: ["./add-lr-module.component.css"],
})
export class AddLrModuleComponent {
  today = new Date().toISOString().split("T")[0];
  yesterday = new Date(Date.now() - 86400000).toISOString().split("T")[0];
  vehicleRatees: any = 0;
  materials = [];
  material: any;
  rateChart: any;
  paramId: any;
  isMultiple = true;
  imageSrc: any;
  imageSrcpodback: any;
  companyList = [];
  companyAddress: any = [{}];
  supervisorIDs: any;
  permitFromVehicle;
  multipletrips = [];
  multipleTrips = [];
  tripIDS = [];
  dropTripID = [];
  list = [];
  val = "";
  shown = false;
  @Input("size") size;
  selected = "Search";
  @ViewChild("searchfield", { static: false }) searchfield: ElementRef;
  onChange: any = () => {};
  check = false;
  dropdownSettings;
  uniqueRes: any = [];
  receipt: any[];
  tripId: any;
  filterdOptions = [];
  vehicles = [];
  DriverNumber;
  labourLoad;
  labourUnload;
  vehiclesNumber = [];
  vehicleType;
  vehicleRoadPermit;
  InvoiceDetails: MatTableDataSource<any> = new MatTableDataSource([]);
  vehicletypes = [];
  vehiclePermitNum = [];
  vehicleTypesNames = [];
  vehiclePermit = [];
  filesToUpload: Array<File> = [];
  Tollfiles: Array<File> = [];
  TollfilesString = [];
  loadingSlips: Array<File> = [];
  loadingSlipsBack: Array<File> = [];
  loadingSlipsString = [];
  loadingSlipsBackString = [];
  clientList = [];
  actualbalance: any = 0;
  updownkm: any = 0;
  totalhour = 0;
  DriverList = [];
  DriverLists = [];
  // DriverNumber;
  DriverNames = [];
  DriverNumbers = [];
  displayedColumns = [
    "noOfArticle",
    "invoiceNo",
    "customerName",
    "invoiceValue",
    "weight",
    "pod",
  ];
  options: string[] = ["One", "Two", "Three"];
  filteredVehicleTypes: Observable<string[]>;
  filteredVehicleRoadPermit: Observable<string[]>;
  filteredConsignorName: Observable<string[]>;
  filteredVehicleNo: Observable<string[]>;
  filteredDriverName: Observable<string[]>;
  filteredDriverNumber: Observable<string[]>;

  isSupervisor = false;

  addNewLR = new FormGroup({
    supervisorname: new FormControl(""),
    clientList: new FormControl("", Validators.compose([Validators.required])),
    manualLR_no: new FormControl(""),
    orderId: new FormControl(""),
    ConsigneeName: new FormControl(
      "",
      Validators.compose([Validators.required])
    ),
    ConsigneeAddress: new FormControl("", Validators.required),
    ConsignorName: new FormControl(
      "",
      Validators.compose([Validators.required])
    ),
    ConsignorAddress: new FormControl("", Validators.required),
    VehicleNo: new FormControl("", Validators.compose([Validators.required])),
    vehicleType: new FormControl(""),
    from: new FormControl(
      "",
      Validators.compose([
        Validators.required,
        Validators.pattern(/^\S+|^\s+\S+/),
      ])
    ),
    to: new FormControl(
      "",
      Validators.compose([
        Validators.required,
        Validators.pattern(/^\S+|^\s+\S+/),
      ])
    ),
    GSTIN: new FormControl(
      "",
      Validators.compose([Validators.required, Validators.maxLength(15)])
    ),
    POD: new FormControl(""),
    date: new FormControl("", []),
    RoadPermitNo: new FormControl("", Validators.required),
    DLY: new FormControl("", Validators.required),
    DeclaredValue: new FormControl(0),
    quantity: new FormControl(
      "",
      Validators.compose([
        Validators.required,
        Validators.pattern(/^\S+|^\s+\S+/),
      ])
    ),
    transportorName: new FormControl(
      "",
      Validators.compose([
        Validators.required,
        Validators.pattern(/^\S+|^\s+\S+/),
      ])
    ),
    transportorMobile: new FormControl(
      "",
      Validators.compose([Validators.required, Validators.pattern(/^\d{10}$/)])
    ),
    driverName: new FormControl(""),
    driverMobile: new FormControl(""),
    customerName: new FormControl("", Validators.required),
    loadingSlipAttchment: new FormControl(""),
    Frieght: new FormControl("", Validators.required),
    InvoiceNo: new FormControl("", Validators.required),
    InvoiceValue: new FormControl("", Validators.required),
    Weight: new FormControl("", Validators.required),
    NoofArticle: new FormControl("", Validators.required),
    tripSDate: new FormControl("", Validators.required),
    tripEDate: new FormControl(""),
    otherPayment: new FormControl("", Validators.pattern("^[0-9]*$")),
    detention: new FormControl("", Validators.pattern("^[0-9]*$")),
    advance: new FormControl(
      "",
      Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])
    ),
    balance: new FormControl(""),
    balancePaid: new FormControl(
      "",
      Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])
    ),
    vehicleRate: new FormControl(
      "",
      Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])
    ),
    tripIdGeneration: new FormControl("False", Validators.required),
    labourLoad: new FormControl(""),
    labourUnload: new FormControl(""),

    TDS: new FormControl("", Validators.pattern("^[0-9]*$")),
    munsipalAmount: new FormControl("", Validators.pattern("^[0-9]*$")),
    finalAmount: new FormControl("", Validators.pattern("^[0-9]*$")),
    otherPaymentDescription: new FormControl(""),
  });
  docURL: any;
  podURL: any;
  podParticularURL: any;

  @ViewChild("showDoc") showDoc: ElementRef;
  @ViewChild("showPOD") showPOD: ElementRef;
  @ViewChild("showParticularPOD") showParticularPOD: ElementRef;
  superVisor: any;
  rate: any;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer
  ) {
    this.activatedRoute.params.subscribe((param) => {
      this.paramId = param.id;
      this.getVehicleDetails();
    });

    if (this.paramId == "single") {
      this.isMultiple = false;
    }
  }
  count_user_click = 0;
  decValue = 0;
  submitLRClicked = false;
  userSessionData: any;
  get ff() {
    return this.addNewLR.controls;
  }
  ngOnInit(): void {
    const session = sessionStorage.getItem("userSession");
    this.userSessionData = session ? JSON.parse(session) : null;

    if (this.userSessionData?.user_role_id?.[0] == 2) {
      this.isSupervisor = true;
    }

    if (this.isSupervisor) {
      this.addNewLR.get("date").setValidators([Validators.required]);
      this.addNewLR.get("date").updateValueAndValidity();
    }
    this.getVehicleType();
    this.getClientList();
    this.getDriverNames();
    this.getSuperVisorName();
    this.getLR();
  }
  getDriverNames() {
    this.superAdminService.getDrivers().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.DriverList = rawdata;
          this.DriverLists = this.DriverList.map((x) => x.driver_name);
          this.DriverList.forEach((item) => {
            if (item.driver_name) {
              this.DriverNames.push(item.driver_name);
            }
            if (item.contactNumber) {
              this.DriverNumbers.push(item.contactNumber);
            }
          });
          this.filteredDriverName = this.ff.driverName.valueChanges.pipe(
            startWith(""),
            map((value) => this._filterDriverName(value || ""))
          );
          this.filteredDriverNumber = this.ff.driverMobile.valueChanges.pipe(
            startWith(""),
            map((value) => this._filterDriverNumber(value || ""))
          );
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      },
      (error) => {}
    );
  }
  private _filterDriverName(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.DriverNames.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }
  private _filterDriverNumber(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.DriverNumbers.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }
  getClientList() {
    this.superAdminService.getClientList().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status === true) {
          this.clientList = res.data || [];
          this.companyList = this.clientList.map((x) => x.clientName);

          // Null check for sessionStorage
          const session = sessionStorage.getItem("userSession");
          this.userSessionData = session ? JSON.parse(session) : null;

          // Only proceed if userSessionData is valid
          if (this.userSessionData?.user_role_id?.length) {
            const userroleid = this.userSessionData.user_role_id[0];

            if (userroleid !== 1) {
              const clients = this.userSessionData.clientList || [];

              // Replace clientList with only permitted clients
              this.clientList = clients
                .map((id) => this.clientList.find((item) => item._id === id))
                .filter((item) => !!item);
            }
          }
        } else {
          if (res.status === 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getVehicleType() {
    // console.log("hhh")
    this.superAdminService.getVehicleType().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.vehicletypes = rawdata;
          this.vehicletypes.forEach((item) => {
            this.vehicleTypesNames.push(item.vehicletype_name);
          });
          this.filteredVehicleTypes = this.ff.vehicleType.valueChanges.pipe(
            startWith(""),
            map((value) => this._filterVehicleType(value || ""))
          );
          //this.dtOptions.data = this.users;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      },
      (error) => {}
    );
  }

  getvehiclePermit() {
    // console.log("ddddd")
    var NO = this.permitFromVehicle;
    this.superAdminService
      .getVehiclePermit(NO)
      .subscribe((res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.vehiclePermitNum = rawdata;
          this.vehiclePermitNum.forEach((item) => {
            this.vehiclePermit.push(item.permitNumber);
          });
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      });
  }
  private _filterVehicleType(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.vehicleTypesNames.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  private _filterVehiclePermit(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.vehiclePermitNum.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }
  getVehicleDetails() {
    this.superAdminService.getvehicles().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          this.vehicles = res.data;
          this.vehicles.forEach((item) => {
            this.vehiclesNumber.push(item.vehicle_no);
          });
          this.filteredVehicleNo = this.ff.VehicleNo.valueChanges.pipe(
            startWith(""),
            map((value) => this._filterVehicleNo(value || ""))
          );
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            this.addNewLR.patchValue({
              driverMobile: this.DriverNumber,
            });
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      },
      (error) => {}
    );
  }
  private _filterVehicleNo(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.vehiclesNumber.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }
  fileChangeEventtollAttachment(fileInput: any) {
    for (var i = 0; i < fileInput.target.files.length; i++) {
      this.Tollfiles.push(fileInput.target.files[i]);
    }
  }
  // loadingSlips: File[] = [];              // to store selected files
  previewLoadingSlips: string[] = []; // to store preview URLs

  uploadedFilePaths: string[] = []; // Server returned paths
  fileNames: string[] = [];

  lastFileName: string = ""; // Only last uploaded file name

  fileChangeEventLoadingSlipAttachment(event: any) {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // Store file for upload
      this.loadingSlips.push(file);

      // Update last uploaded file name
      this.lastFileName = file.name;

      // Handle preview
      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.previewLoadingSlips.push(e.target.result); // Base64 for image preview
        };
        reader.readAsDataURL(file);
      } else if (file.type === "application/pdf") {
        // Mark PDF preview placeholder
        this.previewLoadingSlips.push("pdf-placeholder");
      } else {
        // Skip unsupported file types
        console.warn("Unsupported file type:", file.type);
      }
    }

    // Allow re-upload of same file
    event.target.value = "";
  }

  // Open file chooser
  addMoreFiles() {
    document.getElementById("loadingSlipAttachmentCtrl")?.click();
  }

  // Remove a selected file
  removeFile(index: number) {
    this.previewLoadingSlips.splice(index, 1);
    this.loadingSlips.splice(index, 1);

    this.lastFileName = this.loadingSlips.length
      ? this.loadingSlips[this.loadingSlips.length - 1].name
      : "";
  }

  // View image in new tab
  viewImage(imgBase64: string) {
    const newTab = window.open();
    if (newTab) {
      newTab.document.write(`
      <html>
        <head><title>View Image</title></head>
        <body style="margin:0;display:flex;justify-content:center;align-items:center;background:#000;">
          <img src="${imgBase64}" style="max-width:100%;max-height:100vh;" />
        </body>
      </html>
    `);
    } else {
      console.error("Failed to open new tab");
    }
  }

  // View PDF in new tab
  viewPdf(index: number) {
    const file = this.loadingSlips[index];
    if (file && file.type === "application/pdf") {
      const url = URL.createObjectURL(file);
      window.open(url, "_blank");
    } else {
      console.error("No PDF file found for preview");
    }
  }

  // Check if item is image for preview rendering
  isImage(fileUrl: string) {
    return fileUrl && fileUrl.startsWith("data:image");
  }

  // Upload API call
  uploadLoadingSlips() {
    if (!this.loadingSlips.length) return;

    const formData = new FormData();
    this.loadingSlips.forEach((file) =>
      formData.append("loadingSlips[]", file)
    );

    return this.superAdminService.addloadingSlips(formData);
  }

  readURL(event: any, pod: any): void {
    if (pod === "front") {
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];

        const reader = new FileReader();
        reader.onload = (e) => (this.imageSrc = reader.result);

        reader.readAsDataURL(file);
      }
    } else {
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];

        const reader = new FileReader();
        reader.onload = (e) => (this.imageSrcpodback = reader.result);

        reader.readAsDataURL(file);
      }
    }
  }
  clearpodfront(pod: any) {
    if (pod === "front") {
      this.imageSrc = "";
    } else {
      this.imageSrcpodback = "";
    }
  }

  fileChangeEventloadingSlipBackAttchment(fileInput: any) {
    this.loadingSlipsBack = [];
    for (var i = 0; i < fileInput.target.files.length; i++) {
      this.loadingSlipsBack.push(fileInput.target.files[i]);
    }
  }

  addTollFiles() {
    if (!this.Tollfiles || this.Tollfiles.length === 0) {
      return;
    }

    const formData = new FormData();

    for (let i = 0; i < this.Tollfiles.length; i++) {
      const file = this.Tollfiles[i];
      if (!(file instanceof File)) {
        console.warn(`Skipping invalid file at index ${i}`, file);
        continue;
      }
      formData.append("Tollfiles[]", file);
    }

    this.superAdminService.addTollFiles(formData).subscribe({
      next: (res: {
        rawdata: any;
        status: any;
        message: any;
        authorization: any;
        code: any;
      }) => {
        if (res.status === true) {
          this.toastr.success(res.message);
          this.TollfilesString = res.rawdata; // backend file paths
        } else if (res.status === 401) {
          this.toastr.error(res.message);
          window.sessionStorage.clear();
          this.router.navigateByUrl("superAuth/login");
        } else {
          this.toastr.error(res.message || "Something went wrong");
        }
      },
      error: (err) => {
        console.error("Error uploading toll files:", err);
        this.toastr.error("Failed to upload toll files");
      },
    });
  }

  addloadingSlips() {
    this.spinner.show();
    const formData = new FormData();
    for (let i = 0; i < this.loadingSlips.length; i++) {
      formData.append("loadingSlips[]", this.loadingSlips[i]);
    }
    this.superAdminService.addloadingSlips(formData).subscribe(
      (res: {
        rawdata: any;
        status: any;
        message: any;
        authorization: any;
        code: any;
      }) => {
        if (res.status == true) {
          this.toastr.success(res.message);
          this.loadingSlipsString = res.rawdata;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
          }
        }
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  addloadingSlipsBack() {
    this.spinner.show();
    const formData = new FormData();
    for (let i = 0; i < this.loadingSlipsBack.length; i++) {
      formData.append("loadingSlipsback[]", this.loadingSlipsBack[i]);
    }
    // debugger;
    this.superAdminService.addloadingSlipsBack(formData).subscribe(
      (res: {
        rawdata: any;
        status: any;
        message: any;
        authorization: any;
        code: any;
      }) => {
        if (res.status == true) {
          this.toastr.success(res.message);
          this.loadingSlipsBackString = res.rawdata;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
          }
        }
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }
  fileChangeEventAttachment(fileInput: any) {
    this.filesToUpload.push(fileInput.target.files[0]);
  }
  onFocusOutEvent(event: any) {
    this.actualbalance =
      parseInt(this.addNewLR.get("vehicleRate").value) -
      parseInt(this.addNewLR.get("advance").value) -
      parseInt(event.target.value);
    this.addNewLR.patchValue({
      balance: this.actualbalance,
    });
  }
  onFocusOutendmeterReading(event: any) {
    this.updownkm =
      parseInt(event.target.value) -
      parseInt(this.addNewLR.get("startmeterReading").value);
    this.addNewLR.patchValue({
      // updownkm: this.updownkm
    });
  }
  getVehicleTypeFromNumber(event: any) {
    this.multipleTrips = [];
    this.multipletrips = [];
    for (let i = 0; i < this.vehicles.length; i++) {
      if (this.vehicles[i].vehicle_no == event.option.value) {
        this.vehicleType = this.vehicles[i].type;

        break;
      }
    }

    for (let i = 0; i < this.tripIDS.length; i++) {
      if (this.tripIDS[i].vehicle_no == event.option.value) {
        this.multipletrips.push(this.tripIDS[i].TripID);
      }
    }
    this.removeDuplicates(this.multipletrips);
    this.multipletrips = this.uniqueRes;
    if (this.multipletrips) {
      this.multipleTrips.push(this.multipletrips);
    } else {
      this.multipleTrips = [];
    }
    this.addNewLR.patchValue({
      vehicleType: this.vehicleType,
    });
  }

  getVehicleRoadPermitNumber(event: any) {
    this.superAdminService
      .getVehiclePermit(event.target.value)
      .subscribe((res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.addNewLR.patchValue({
            RoadPermitNo: rawdata[0].permitNumber,
          });
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      });
  }

  onFocusOuttripEDate(event: any) {
    let outtime = this.addNewLR.get("outtime").value;
    let INtime = this.addNewLR.get("INtime").value;
    let sdate = this.addNewLR.get("tripSDate").value;
    let edate = this.addNewLR.get("tripEDate").value;
    let sd1 = sdate + " " + outtime + ":00";
    let date1 = new Date(sd1);
    let sd2 = edate + " " + INtime + ":00";
    let date2 = new Date(sd2);
    var diff = (date2.getTime() - date1.getTime()) / 1000;
    diff /= 60 * 60;
    let ht: any = Math.abs(Math.round(diff));

    this.addNewLR.patchValue({
      // totalhour: ht
    });
  }
  addInvoiceDetail() {
    var f = {
      id: "inv" + this.count_user_click,
      InvoiceNo: document.getElementById("InvoiceNoctrl")["value"],
      InvoiceValue: document.getElementById("InvoiceValuectrl")["value"],
      NoofArticle: document.getElementById("NoofArticlectrl")["value"],
      Weight: document.getElementById("Weightctrl")["value"],
      customerName: document.getElementById("customerNamectrl")["value"],
      POD: document.getElementById("PODctrl")["value"],
    };
    if (
      document.getElementById("InvoiceNoctrl")["value"] != "" &&
      document.getElementById("InvoiceValuectrl")["value"] != "" &&
      document.getElementById("NoofArticlectrl")["value"] != "" &&
      document.getElementById("Weightctrl")["value"] != "" &&
      document.getElementById("customerNamectrl")["value"] != ""
    ) {
      this.count_user_click += 1;
      let temp = this.InvoiceDetails.filteredData;
      temp.push(f);
      this.InvoiceDetails = new MatTableDataSource(temp);

      this.decValue += parseInt(
        document.getElementById("InvoiceValuectrl")["value"]
      );
      this.addNewLR.patchValue({
        DeclaredValue: this.decValue,
      });

      document.getElementById("InvoiceNoctrl")["value"] = "";
      document.getElementById("InvoiceValuectrl")["value"] = "";
      document.getElementById("NoofArticlectrl")["value"] = "";
      document.getElementById("Weightctrl")["value"] = "";
      document.getElementById("Frieghtctrl")["value"] = "";
      document.getElementById("customerNamectrl")["value"] = "";
      document.getElementById("PODctrl")["value"] = "";
      this.removevalidatorcss("InvoiceNoctrl");
      this.removevalidatorcss("InvoiceValuectrl");
      this.removevalidatorcss("NoofArticlectrl");
      this.removevalidatorcss("Weightctrl");
      this.removevalidatorcss("Frieghtctrl");
      this.removevalidatorcss("customerNamectrl");
      this.removevalidatorcss("PODctrl");
    } else {
      if (this.addNewLR.get("InvoiceNo").invalid) {
        this.addvalidatorcss("InvoiceNoctrl");
      } else {
        this.removevalidatorcss("InvoiceNoctrl");
      }
      if (this.addNewLR.get("InvoiceValue").invalid) {
        this.addvalidatorcss("InvoiceValuectrl");
      } else {
        this.removevalidatorcss("InvoiceValuectrl");
      }
      if (this.addNewLR.get("NoofArticle").invalid) {
        this.addvalidatorcss("NoofArticlectrl");
      } else {
        this.removevalidatorcss("NoofArticlectrl");
      }
      if (this.addNewLR.get("Weight").invalid) {
        this.addvalidatorcss("Weightctrl");
      } else {
        this.removevalidatorcss("Weightctrl");
      }
      if (this.addNewLR.get("customerName").invalid) {
        this.addvalidatorcss("customerNamectrl");
      } else {
        this.removevalidatorcss("customerNamectrl");
      }
    }
  }
  getSuperVisorName() {
    this.superAdminService.getSuperVisorName().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.superVisor = rawdata;
          //this.dtOptions.data = this.users;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
          }
        }
      },
      (error) => {}
    );
  }

  addNewLRSubmit() {
    this.addNewLR.markAllAsTouched();
    this.submitLRClicked = true;

    if (this.addNewLR.get("manualLR_no")?.hasError("duplicate")) {
      this.spinner.hide();
      this.toastr.error("Please fix Manual LR number before submitting");
      return;
    }
    if (!this.addNewLR.valid) {
      Object.keys(this.addNewLR.controls).forEach((key) => {
        if (this.addNewLR.get(key).invalid) this.addvalidatorcss(key + "ctrl");
        else this.removevalidatorcss(key + "ctrl");
      });
      return;
    }

    this.spinner.show();

    const submitLR = () => {
      const storedData = JSON.parse(sessionStorage.getItem("userSession"));
      const supervisorIDs =
        storedData.user_role_id[0] == 1
          ? this.addNewLR.get("supervisorname").value
          : storedData._id;

      const form = {
        type: "LR",
        manualLR_no: this.addNewLR.get("manualLR_no").value,
        orderId: this.addNewLR.get("orderId").value,
        supervisorId: supervisorIDs,
        clientList: this.addNewLR.get("clientList").value,
        TripID: this.addNewLR.get("tripIdGeneration").value,
        consignee_name: this.addNewLR.get("ConsigneeName").value,
        consignee_address: this.addNewLR.get("ConsigneeAddress").value,
        consignor_name: this.addNewLR.get("ConsignorName").value,
        consignor_address: this.addNewLR.get("ConsignorAddress").value,
        VehicleNo: this.addNewLR.get("VehicleNo").value,
        vehicleType: this.addNewLR.get("vehicleType").value,
        GSTIN: this.addNewLR.get("GSTIN").value,
        from: this.addNewLR.get("from").value,
        to: this.addNewLR.get("to").value,
        date: this.addNewLR.get("date").value,
        quantity: this.addNewLR.get("quantity").value,
        road_permit_no: this.addNewLR.get("RoadPermitNo").value,
        dly_no: this.addNewLR.get("DLY").value,
        declared_value: this.addNewLR.get("DeclaredValue").value,
        transportorName: this.addNewLR.get("transportorName").value,
        transportorMobile: this.addNewLR.get("transportorMobile").value,
        driverName: this.addNewLR.get("driverName").value,
        driverMobile: this.addNewLR.get("driverMobile").value,
        customerName: this.addNewLR.get("customerName").value,
        loadingSlipAttchment: this.loadingSlipsString, // Uploaded file URLs
        Frieght: this.addNewLR.get("Frieght").value,
        InvoiceValue: this.addNewLR.get("InvoiceValue").value,
        Weight: this.addNewLR.get("Weight").value,
        NoofArticle: this.addNewLR.get("NoofArticle").value,
        detention: this.addNewLR.get("detention").value,
        advance: this.addNewLR.get("advance").value,
        balance: this.addNewLR.get("balance").value,
        balancePaid: this.addNewLR.get("balancePaid").value,
        vehicleRate: this.addNewLR.get("vehicleRate").value,
        invoice_no: this.InvoiceDetails.data,
        tripStartDate: this.addNewLR.get("tripSDate").value,
        tripEndDate: this.addNewLR.get("tripEDate").value,
        labourLoad: this.addNewLR.get("labourLoad").value,
        labourUnload: this.addNewLR.get("labourUnload").value,
        otherPayment: this.addNewLR.get("otherPayment").value,
        otherPaymentDescription: this.addNewLR.get("otherPaymentDescription")
          ?.value,

        TDS: this.addNewLR.get("TDS")?.value,
        munsipalAmount: this.addNewLR.get("munsipalAmount")?.value,
        finalAmount: this.addNewLR.get("finalAmount")?.value,
      };

      const formData = new FormData();
      if (this.filesToUpload?.length) {
        this.filesToUpload.forEach((file) =>
          formData.append("uploads[]", file)
        );
      }
      formData.append("myFormData", JSON.stringify(form));

      this.superAdminService.createLR(formData).subscribe({
        next: (res: any) => {
          if (res.status) {
            this.toastr.success(res.message);
            const route = ["/superAdmin/lrmanagement/detail-lr/" + res.data];
            this.router.navigate(route);
            if (this.isMultiple) this.addNewLR.reset();
          } else {
            this.toastr.error(res.message);
          }
          this.spinner.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide();
        },
      });
    };

    // Upload files first if any new files are selected
    if (this.loadingSlips.length) {
      const formDataFiles = new FormData();
      this.loadingSlips.forEach((file) =>
        formDataFiles.append("loadingSlips[]", file)
      );

      this.superAdminService.addloadingSlips(formDataFiles).subscribe({
        next: (res: any) => {
          if (res.status) {
            const serverUrls = res.rawdata.map(
              (file: any) => `${environment.domain}${file.url}`
            );
            this.uploadedFilePaths.push(...serverUrls);
            if (!this.loadingSlipsString) this.loadingSlipsString = [];
            this.loadingSlipsString.push(...serverUrls);
            this.loadingSlips = []; // clear local files

            submitLR(); // Submit LR after files uploaded
          } else {
            this.toastr.error(res.message);
            this.spinner.hide();
          }
        },
        error: () => {
          this.toastr.error("Failed to upload loading slips");
          this.spinner.hide();
        },
      });
    } else {
      submitLR();
    }
  }

  resetForm() {
    // Reset the form
    this.addNewLR.reset();
    this.submitLRClicked = false;
    Object.keys(this.addNewLR.controls).forEach((ctrlName) => {
      this.removevalidatorcss(ctrlName);
    });
  }

  addvalidatorcss(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.classList.add("validatorcss");
    } else {
      console.warn(`Element with id "${id}" not found`);
    }
  }

  removevalidatorcss(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.classList.remove("validatorcss");
    }
  }

  onKeyClientName(event: any) {
    if (this.addNewLR.get("clientList").invalid) {
      this.addvalidatorcss("clientListctrl");
    } else {
      this.removevalidatorcss("clientListctrl");
    }
  }
  onKeyConsigneeName(event: any) {
    if (this.addNewLR.get("ConsigneeName").invalid) {
      this.addvalidatorcss("ConsigneeNamectrl");
    } else {
      this.removevalidatorcss("ConsigneeNamectrl");
    }
  }
  onKeyConsigneeAddress(event: any) {
    if (this.addNewLR.get("ConsigneeAddress").invalid) {
      this.addvalidatorcss("ConsigneeAddressctrl");
    } else {
      this.removevalidatorcss("ConsigneeAddressctrl");
    }
  }
  onKeyConsignorName(event: any) {
    if (this.addNewLR.get("ConsignorName").invalid) {
      this.addvalidatorcss("ConsignorNamectrl");
    } else {
      this.removevalidatorcss("ConsignorNamectrl");
    }
  }
  onKeyConsignorAddress(event: any) {
    if (this.addNewLR.get("ConsignorAddress").invalid) {
      this.addvalidatorcss("ConsignorAddressctrl");
    } else {
      this.removevalidatorcss("ConsignorAddressctrl");
    }
  }
  onKeyVehicleNo(event: any) {
    if (this.addNewLR.get("VehicleNo").invalid) {
      this.addvalidatorcss("VehicleNoctrl");
    } else {
      this.removevalidatorcss("VehicleNoctrl");
    }
  }
  onKeyVehicleType(event: any) {
    if (this.addNewLR.get("vehicleType").invalid) {
      this.addvalidatorcss("vehicleTypectrl");
    } else {
      this.removevalidatorcss("vehicleTypectrl");
    }
  }
  onKeyFrom(event: any) {
    if (this.addNewLR.get("from").invalid) {
      this.addvalidatorcss("fromctrl");
    } else {
      this.removevalidatorcss("fromctrl");
    }
  }
  onKeyTo(event: any) {
    if (this.addNewLR.get("to").invalid) {
      this.addvalidatorcss("toctrl");
    } else {
      this.removevalidatorcss("toctrl");
    }
  }
  onKeyGSTIN(event: any) {
    if (this.addNewLR.get("GSTIN").invalid) {
      this.addvalidatorcss("GSTINctrl");
    } else {
      this.removevalidatorcss("GSTINctrl");
    }
  }
  onKeyDate(event: any) {
    const inputDate = new Date(this.addNewLR.get("date").value);
    inputDate.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    if (inputDate < yesterday || inputDate > today) {
      this.addNewLR.get("date").setValue("");
    }
    if (this.addNewLR.get("date").invalid) {
      this.addvalidatorcss("datectrl");
    } else {
      this.removevalidatorcss("datectrl");
    }
  }
  onKeyRoadPermitNo(event: any) {
    if (this.addNewLR.get("RoadPermitNo").invalid) {
      this.addvalidatorcss("RoadPermitNoctrl");
    } else {
      this.removevalidatorcss("RoadPermitNoctrl");
    }
  }
  onKeyDLY(event: any) {
    if (this.addNewLR.get("DLY").invalid) {
      this.addvalidatorcss("DLYctrl");
    } else {
      this.removevalidatorcss("DLYctrl");
    }
  }
  onKeyDeclaredValue(event: any) {
    if (this.addNewLR.get("DeclaredValue").invalid) {
      this.addvalidatorcss("DeclaredValuectrl");
    } else {
      this.removevalidatorcss("DeclaredValuectrl");
    }
  }
  onKeytransportorName(event: any) {
    if (this.addNewLR.get("transportorName").invalid) {
      this.addvalidatorcss("transportorNamectrl");
    } else {
      this.removevalidatorcss("transportorNamectrl");
    }
  }
  onKeytransportorMobile(event: any) {
    if (this.addNewLR.get("transportorMobile").invalid) {
      this.addvalidatorcss("transportorMobilectrl");
    } else {
      this.removevalidatorcss("transportorMobilectrl");
    }
  }
  onKeyDriverName() {
    if (this.addNewLR.get("driverName").invalid) {
      this.addvalidatorcss("driverNamectrl");
    } else {
      this.removevalidatorcss("driverNamectrl");
    }
  }
  onKeyDriverMobile(event: any) {
    if (this.addNewLR.get("driverMobile").invalid) {
      this.addvalidatorcss("driverMobilectrl");
    } else {
      this.removevalidatorcss("driverMobilectrl");
    }
  }

  onKeyFrieght(event: any) {
    if (this.addNewLR.get("Frieght").invalid) {
      this.addvalidatorcss("Frieghtctrl");
    } else {
      this.removevalidatorcss("Frieghtctrl");
    }
  }

  onKeyloadingSlipAttchment(event: any) {
    if (this.addNewLR.get("loadingSlipAttchment").invalid) {
      this.addvalidatorcss("loadingSlipAttchmentctrl");
    } else {
      this.removevalidatorcss("loadingSlipAttchmentctrl");
    }
  }

  onKeyloadingSlipBackAttchment(event: any) {
    if (this.addNewLR.get("loadingSlipAttchmentBack").invalid) {
      this.addvalidatorcss("loadingSlipAttchmentBackctrl");
    } else {
      this.removevalidatorcss("loadingSlipAttchmentBackctrl");
    }
  }
  onKeyInvoiceNo(event: any) {
    if (this.addNewLR.get("InvoiceNo").invalid) {
      this.addvalidatorcss("InvoiceNoctrl");
    } else {
      this.removevalidatorcss("InvoiceNoctrl");
    }
  }
  onKeyInvoiceValue(event: any) {
    if (this.addNewLR.get("InvoiceValue").invalid) {
      this.addvalidatorcss("InvoiceValuectrl");
    } else {
      this.removevalidatorcss("InvoiceValuectrl");
    }
  }
  onKeyNoofArticle(event: any) {
    if (this.addNewLR.get("NoofArticle").invalid) {
      this.addvalidatorcss("NoofArticlectrl");
    } else {
      this.removevalidatorcss("NoofArticlectrl");
    }
  }
  onKeyQuantity(event: any) {
    if (this.addNewLR.get("quantity").invalid) {
      this.addvalidatorcss("quantityctrl");
    } else {
      this.removevalidatorcss("quantityctrl");
    }
  }
  onKeyWeight(event: any) {
    if (this.addNewLR.get("Weight").invalid) {
      this.addvalidatorcss("Weightctrl");
    } else {
      this.removevalidatorcss("Weightctrl");
    }
  }
  onKeyTransportorName(event: any) {
    if (this.addNewLR.get("transportorName").invalid) {
      this.addvalidatorcss("transportorNamectrl");
    } else {
      this.removevalidatorcss("transportorNamectrl");
    }
  }
  onKeyTransportorMobile(event: any) {
    if (this.addNewLR.get("transportorMobile").invalid) {
      this.addvalidatorcss("transportorMobilectrl");
    } else {
      this.removevalidatorcss("transportorMobilectrl");
    }
  }
  onKeyCustomerName(event: any) {
    if (this.addNewLR.get("customerName").invalid) {
      this.addvalidatorcss("customerNamectrl");
    } else {
      this.removevalidatorcss("customerNamectrl");
    }
  }

  backTo() {
    window.history.back();
  }
  get gstin() {
    return this.addNewLR.get("GSTIN");
  }
  get InvoiceValue() {
    return this.addNewLR.get("InvoiceValue");
  }

  get Weight() {
    return this.addNewLR.get("Weight");
  }

  get NoofArticle() {
    return this.addNewLR.get("NoofArticle");
  }
  preview(index) {
    let file = this.filesToUpload[index];
    if (file) {
      if (
        ["image/jpeg", "image/png", "image/svg", "image/svg+xml"].includes(
          file.type
        )
      ) {
        const dialogRef = this.dialog.open(ImagePreviewComponent, {
          width: "80%",
          height: "90vh",
          data: { file: file },
        });
      } else {
        let url = URL.createObjectURL(file);
        this.podParticularURL = this.sanitizer.bypassSecurityTrustUrl(url);
        setTimeout(() => {
          this.showParticularPOD.nativeElement.click();
        });
      }
    } else {
      this.toastr.error("Please upload attachment");
    }
  }
  previewLR() {
    if (this.loadingSlips[0]) {
      if (
        ["image/jpeg", "image/png", "image/svg", "image/svg+xml"].includes(
          this.loadingSlips[0].type
        )
      ) {
        const dialogRef = this.dialog.open(ImagePreviewComponent, {
          width: "80%",
          height: "90vh",
          data: { file: this.loadingSlips[0] },
        });
      } else {
        let url = URL.createObjectURL(this.loadingSlips[0]);
        this.docURL = this.sanitizer.bypassSecurityTrustUrl(url);
        setTimeout(() => {
          this.showDoc.nativeElement.click();
        });
      }
    } else {
      this.toastr.error("Please upload attachment");
    }
  }

  previewLRBack() {
    if (this.loadingSlipsBack[0]) {
      if (
        ["image/jpeg", "image/png", "image/svg", "image/svg+xml"].includes(
          this.loadingSlipsBack[0].type
        )
      ) {
        const dialogRef = this.dialog.open(ImagePreviewComponent, {
          width: "80%",
          height: "90vh",
          data: { file: this.loadingSlipsBack[0] },
        });
      } else {
        let url = URL.createObjectURL(this.loadingSlipsBack[0]);
        this.docURL = this.sanitizer.bypassSecurityTrustUrl(url);
        setTimeout(() => {
          this.showDoc.nativeElement.click();
        });
      }
    } else {
      this.toastr.error("Please upload attachment");
    }
  }
  previewPOD() {
    let file = this.filesToUpload.slice(-1)[0];
    if (file) {
      if (
        ["image/jpeg", "image/png", "image/svg", "image/svg+xml"].includes(
          file.type
        )
      ) {
        const dialogRef = this.dialog.open(ImagePreviewComponent, {
          width: "80%",
          height: "90vh",
          data: { file: file },
        });
      } else {
        let url = URL.createObjectURL(file);
        this.podURL = this.sanitizer.bypassSecurityTrustUrl(url);
        setTimeout(() => {
          this.showPOD.nativeElement.click();
        });
      }
    } else {
      this.toastr.error("No file selected for Preview");
    }
  }

  onFocusDriverName(event: any) {
    // console.log("clickeeeee")
    for (let i = 0; i < this.DriverList.length; i++) {
      if (this.DriverList[i].driver_name == event) {
        this.DriverNumber = this.DriverList[i].contactNumber;
      }
    }
    this.addNewLR.patchValue({
      driverMobile: this.DriverNumber,
    });
    this.onKeyDriverName();
  }

  checktripid(event: any) {
    if (event == "true") {
      this.check = true;
    } else {
      this.check = false;
    }
  }

  getLR() {
    this.superAdminService.getlrs().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;

          var receiptData = [];
          for (let i = 0; i < rawdata.length; i++) {
            receiptData.push(rawdata[i].receipt);
          }

          for (let i = 0; i < receiptData.length; i++) {
            this.dropTripID.push(receiptData[i].TripID);
          }

          this.dropdownSettings = {
            singleSelection: true,
            searchPlaceholderText: "Search",
            idField: "item_id",
            textField: "item_text",
            allowSearchFilter: true,
            unSelectAllText: "UnSelect All",
          };
        } else {
          if (res.status == 401) {
            this.spinner.hide();
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
            this.spinner.hide();
          }
        }
      },
      (error) => {
        this.toastr.error("Something went wrong! Please contact us");
        this.spinner.hide();
      }
    );
  }

  removeDuplicates(arr) {
    let unique = [];
    arr.forEach((element) => {
      if (!unique.includes(element)) {
        unique.push(element);
      }
    });
    this.uniqueRes = unique;

    return unique;
  }

  getCompanyAddress(event: any) {
    this.companyAddress = [{}];
    this.companyAddress.push(event.option.value);
    let temp = [];
    this.clientList.map((x) => {
      this.companyAddress.map((y) => {
        if (x.clientName == y) {
          temp.push({ address: x.address });
        }
      });
    });
    this.addNewLR.patchValue({
      ConsignorAddress: temp[0].address,
    });
  }

  getCompanyAddressCon(event: any) {
    this.companyAddress = [{}];
    this.companyAddress.push(event.option.value);
    let temp = [];
    this.clientList.map((x) => {
      this.companyAddress.map((y) => {
        if (x.clientName == y) {
          temp.push({ address: x.address, gst: x.CGSTNumber });
        }
      });
    });
    this.addNewLR.patchValue({
      ConsigneeAddress: temp[0].address,
      GSTIN: temp[0].gst,
    });
  }
  focusonWeight(event: any) {
    var formDatas = {
      from: this.addNewLR.get("from").value,
      to: this.addNewLR.get("to").value,
      weight: this.addNewLR.get("quantity").value,
    };
  }

  fetchRateChart() {
    this.superAdminService.getRateChart().subscribe((res: any) => {
      if (res.status == true) {
        let rawdata = res.data;
        this.rate = rawdata;
      } else {
        if (res.status == 401) {
          this.toastr.error(res.message);
        }
      }
    });
  }

  onManualLRFocus() {
    const ctrl = this.addNewLR.get("manualLR_no");

    if (ctrl?.hasError("duplicate")) {
      ctrl.setErrors(null);
    }

    this.removevalidatorcss("manualLR_noctrl");
  }

  onManualLRBlur() {
    const ctrl = this.addNewLR.get("manualLR_no");
    const manualLRNo = ctrl?.value?.trim();

    if (!manualLRNo) return;

    this.superAdminService.checkManualLR(manualLRNo).subscribe({
      next: (res) => {
        if (res.exists) {
          // Duplicate found
          ctrl?.setErrors({ duplicate: true });
          this.addvalidatorcss("manualLR_noctrl");
          this.toastr.error(res.message || "Manual LR number already exists");
        } else {
          // Valid
          if (ctrl?.hasError("duplicate")) {
            ctrl.setErrors(null);
          }
          this.removevalidatorcss("manualLR_noctrl");
        }
      },
      error: () => {
        // this.toastr.error("Failed to validate Manual LR number");
      },
    });
  }
}
